import styled from 'styled-components';

const StyledExpenseCategoryIcon = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_8};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 56px;
  width: 56px;

  svg {
    height: 24px;
    width: 24px;

    *[fill] {
      fill: ${props => props.theme.colors.neutral_1} !important;
    }

    *[stroke] {
      stroke: ${props => props.theme.colors.neutral_1} !important;
    }
  }
`;

export {
  StyledExpenseCategoryIcon,
}
